import { BackdropClassPipe } from './backdrop-class.pipe';
import { CanUploadSignedReportPipe } from './can-upload-signed-report.pipe';
import { DisplayESignButtonPipe } from './display-e-sign-button.pipe';
import { LockStatusPipe } from './lock-status.pipe';
import { ESignStatusIconPipe } from './e-sign-status-icon.pipe';
import { UploadSignedReportTooltipPipe } from './upload-signed-report-tooltip.pipe';
import { ESignStatusTextPipe } from './e-sign-status-text.pipe';
import { ESignStatusColorPipe } from './e-sign-status-color.pipe';
import { ESignStatusChangePipe } from './e-sign-status-change.pipe';
import { DateDiffPipe } from './date-diff.pipe';
import { DateRangeDurationPipe } from './date-range-duration.pipe';
import { DateRangePresetComparerPipe } from './date-range-preset-comparer.pipe';
import { SelectedStatusFilterNamesPipe } from './selected-status-filter-names.pipe';
import { DownloadButtonDisabledTooltip } from './download-button-disabled-tooltip.pipe';

export {
  BackdropClassPipe,
  DisplayESignButtonPipe,
  LockStatusPipe,
  CanUploadSignedReportPipe,
  UploadSignedReportTooltipPipe,
  ESignStatusIconPipe,
  ESignStatusColorPipe,
  ESignStatusChangePipe,
  DateDiffPipe,
  DateRangeDurationPipe,
  DateRangePresetComparerPipe,
  SelectedStatusFilterNamesPipe,
  DownloadButtonDisabledTooltip,
};

export const pipes = [
  BackdropClassPipe,
  DisplayESignButtonPipe,
  LockStatusPipe,
  CanUploadSignedReportPipe,
  UploadSignedReportTooltipPipe,
  ESignStatusIconPipe,
  ESignStatusTextPipe,
  ESignStatusColorPipe,
  ESignStatusChangePipe,
  DateDiffPipe,
  DateRangeDurationPipe,
  DateRangePresetComparerPipe,
  SelectedStatusFilterNamesPipe,
  DownloadButtonDisabledTooltip,
];
